import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  paper: {
    position:   'relative',
    paddingTop: theme.spacing(2),
  },
  title: {
    textAlign:     'center',
    position:      'relative',
    width:         '100%',
    paddingBottom: theme.spacing(2),
    whiteSpace:    'nowrap',
    overflow:      'hidden',
    textOverflow:  'ellipsis',
    fontWeight:    theme.typography.fontWeightSemibold,
    fontSize:      '0.875rem',
  },
}));

export default useStyles;
